import styled from 'styled-components';
import {COLORS} from '../../../common/colors'
import { h } from 'preact';

const {CONTRAST_WCAG_BORDER} = COLORS;
export const StyledButtonsDiv = styled.div`
  margin: 0 auto;
  ${({ isInviteReflow }) => isInviteReflow ? `
    display: flex;
    min-height: fit-content;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 0 20px;

    @media screen and (max-width: 420px) {
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      padding: 0 22px;
      button {
        padding-left: 6px;
        padding-right: 6px;
        width: 100%;
      }
    }
    @media screen and (max-width: 250px) {
      padding: 0 10px;
    }
  ` : `
    display: table;
    min-height: 44px;
  `};
`;

export const StyledDeclineButtonContainer = styled.div`
  float: ${({isDirectionRtl}) => isDirectionRtl ? 'right' : 'none'};
  display: inline-block;
  margin: ${({isDirectionRtl}) => isDirectionRtl ? '0 0 10px 8px' : '0 8px 10px 0'};
`;

export const StyledProvideButtonContainer = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  float: right;
`;

export const StyledButton = styled.button`
  color:${({textColor}) => textColor};
  --bgColor: ${({buttonColor}) => buttonColor};
  --bgColor-lighter: color-mix(in srgb, var(--bgColor) 70%, white);
  --bgColor-darker: color-mix(in srgb, var(--bgColor) 80%, black);
  background-color: var(--bgColor);
  transition: background-color 0.3s ease 0s;
  opacity: 1;
  box-shadow: none;
  outline: none;
  position: relative;
  min-width: 120px;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  min-height: 34px;
  height: fit-content;
  font-size:  ${({isInviteReflow}) => isInviteReflow ? '0.875rem' : '14px'};
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-appearance: button;
  overflow: visible;
  ${({ isInviteReflow }) => isInviteReflow ? `
    overflow: hidden;
    word-wrap: break-word;
    white-space: normal;
    text-align: center;
    @media screen and (max-width: 250px) {
      min-width: unset;
    }
  ` : ''}
  margin: 0;
  border:${({isDeclineButton}) => isDeclineButton ? `1px solid ${CONTRAST_WCAG_BORDER}` : 'none' };
  &:hover, &:focus{
      color: ${({isDeclineButton}) => isDeclineButton ? 'black' : 'white'};
      background-color: ${({isDeclineButton}) => isDeclineButton ? 'var(--bgColor-lighter)' :  'var(--bgColor-darker)'};
      border:${({isDeclineButton}) => isDeclineButton ? `1px solid black` : 'none'};
  }
  &:focus{
    outline: ${COLORS.BLUE_WCAG_BORDER} solid 2px;
    outline-offset: 2px;
  }
`;